// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import styles from './form.module.less';
import {t_methods} from './types';
import cn from 'classnames';
// @ts-ignore
import {capitalize} from '/util/string.js';
import {Button} from '../../lib/button';

interface i_method_button_props {
    children?: JSX.Element;
    type: t_methods;
    signup_mode: boolean;
    on_click: (type:t_methods)=>void;
}
export const Method_button = (props: i_method_button_props)=>{
    let login_with = 'Continue with';
    return <Button cls={cn(styles.auth_method, styles[props.type])}
      color="social" on_click={()=>{ props.on_click(props.type); }}
      caption={<div className={styles.auth_method_btn}>
        {login_with} {capitalize(props.type)}
      </div>} icon_left={props.children}/>;
};
